import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginJuridicoComponent } from  './juridico/paginas/login/login.component';
import { RecuperarSenhaComponent } from "./ambos/paginas/recuperar-senha/recuperar-senha.component";
import { NaoEncontradaComponent } from './juridico/paginas/nao-encontrada/nao-encontrada.component';
import { CancelarEnvioEmailComponent } from './juridico/paginas/cancelar-envio-email/cancelar-envio-email.component';
import { UsuarioNaoEncontradoComponent } from './juridico/paginas/usuario-nao-encontrado/usuario-nao-encontrado.component';
import { environment } from 'src/environments/environment';
import { dataSeo } from './app.data.seo';


const routes: Routes = [
  //{ path: 'cadastrar', component: CadastroJuridicoComponent, data: dataSeo.cadastrar },
  { path: '', component: LoginJuridicoComponent, data: dataSeo.login },
  { path: ':redirect', component: LoginJuridicoComponent, data: dataSeo.login },
  { path: 'desabilitando-envio-email/:tipo', component: CancelarEnvioEmailComponent, data: dataSeo.desabilitandoEnvioEmail },
  { path: 'usuario-nao-encontrado', component: UsuarioNaoEncontradoComponent, data: dataSeo.usuarioNaoEncontrado },

  // rotas comuns
  { path: 'recuperar-senha/:email/:codigo', component: RecuperarSenhaComponent, data: dataSeo.recuperarSenha },
  { path: 'ForgotPassword/:email/:codigo', component: RecuperarSenhaComponent, data: dataSeo.forgotPassword },

  { path: '**', component: NaoEncontradaComponent, data: dataSeo.paginaNaoEncontrada },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
